import { render } from "./invalid-dashboard.vue?vue&type=template&id=40bf4584"
import script from "./invalid-dashboard.vue?vue&type=script&lang=js"
export * from "./invalid-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__